export const AMAZON_AUTHOR_URL =
  "https://www.amazon.com/stores/C.-W.-Hambleton/author/B00CWRMYXA";
export const FACEBOOK_URL = "https://www.facebook.com/cwhambleton";
export const X_URL = "https://x.com/cwhambletonbks";
export const YOUTUBE_URL = "https://www.youtube.com/@cwhambletonbooks";
export const GOODREADS_URL =
  "https://www.goodreads.com/author/show/2796110.Chris_Hambleton";
export const CHIRPBOOKS_URL =
  "https://www.chirpbooks.com/authors/c-w-hambleton-audiobooks";
export const ENIGMA_STONEWORKS_URL = "https://enigmastoneworks.com";
